import React from 'react';

function Kenya(props) {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_800_124084)">
        <mask
          id="mask0_800_124084"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124084)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V8H36V0H0Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16V24H36V16H0Z"
            fill="#4E8B1D"
          />
          <path
            d="M0 7H-1V8V16V17H0H36H37V16V8V7H36H0Z"
            fill="#E31D1C"
            stroke="#F7FCFF"
            strokeWidth="2"
          />
        </g>
        <path
          d="M21.3971 3.92897C21.6112 3.53877 22.1868 3.11268 23.1239 2.65069C23.1561 2.63482 23.195 2.63391 23.2281 2.64826C23.2841 2.67254 23.3074 2.73259 23.2797 2.78224L13.5695 20.479L13.064 20.2598L21.6234 4.66026C21.2358 4.60413 21.1604 4.36037 21.3971 3.92897Z"
          fill="white"
        />
        <path
          d="M14.5925 3.92897C14.8292 4.36037 14.7538 4.60413 14.3662 4.66026L22.9256 20.2598L22.4201 20.479L12.7099 2.78224C12.6823 2.73259 12.7055 2.67254 12.7615 2.64826C12.7946 2.63391 12.8335 2.63482 12.8657 2.65069C13.8028 3.11268 14.3784 3.53877 14.5925 3.92897Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 20C19.1213 20 23.625 16.4183 23.625 12C23.625 7.58172 19.1213 4 18 4C16.8787 4 12.375 7.58172 12.375 12C12.375 16.4183 16.8787 20 18 20Z"
          fill="#E31D1C"
        />
        <mask
          id="mask1_800_124084"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="12"
          y="4"
          width="12"
          height="16"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 20C19.1213 20 23.625 16.4183 23.625 12C23.625 7.58172 19.1213 4 18 4C16.8787 4 12.375 7.58172 12.375 12C12.375 16.4183 16.8787 20 18 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_800_124084)">
          <path
            d="M7.3125 19C11.6617 19 15.1875 15.866 15.1875 12C15.1875 8.13401 11.6617 5 7.3125 5C2.96326 5 -0.5625 8.13401 -0.5625 12C-0.5625 15.866 2.96326 19 7.3125 19Z"
            fill="#272727"
          />
          <path
            d="M28.6875 19C33.0367 19 36.5625 15.866 36.5625 12C36.5625 8.13401 33.0367 5 28.6875 5C24.3383 5 20.8125 8.13401 20.8125 12C20.8125 15.866 24.3383 19 28.6875 19Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2249 10.93C18.7385 10.6058 19.125 9.19333 19.125 7.5C19.125 5.80667 18.7385 4.3942 18.2249 4.06998V10.93ZM17.6624 10.8397C17.206 10.3937 16.875 9.06711 16.875 7.5C16.875 5.93289 17.206 4.60633 17.6624 4.16028V10.8397ZM17.6624 13.1603V19.8397C17.206 19.3937 16.875 18.0671 16.875 16.5C16.875 14.9329 17.206 13.6063 17.6624 13.1603ZM18.2249 19.93V13.07C18.7385 13.3942 19.125 14.8067 19.125 16.5C19.125 18.1933 18.7385 19.6058 18.2249 19.93Z"
            fill="#F7FCFF"
          />
          <path
            d="M18 11C18.6213 11 19.125 11.4477 19.125 12C19.125 12.5523 18.6213 13 18 13C17.3787 13 16.875 12.5523 16.875 12C16.875 11.4477 17.3787 11 18 11Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124084">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Kenya;
